// @ts-nocheck
import { HOLE_W } from "./constants";
import { mapState, mapRefs } from "./state";
import { registerHole, registerDecor } from "./spatial";
import { createPixelFlower } from "./flowers";
import { restoreGrave, renderGravePlaceholder } from "./grave-render";

// === SCENA INIZIALE CURATA (intorno al tempio) ===
// 6 buchi fissi intorno al tempio, alberi ai lati, fiori decorativi
export function buildHomeScene(): void {
  const world = mapRefs.world;
  if (!world) return;

  // Posizioni fisse dei 6 buchi "vetrina" sotto il tempio, su due file.
  const fixedHoles = [
    // Prima fila sotto il tempio
    { id: "home_b1", x: -110, y: 200 },
    { id: "home_b2", x: 0, y: 200 },
    { id: "home_b3", x: 110, y: 200 },
    // Seconda fila sotto il tempio
    { id: "home_t1", x: -110, y: 340 },
    { id: "home_t2", x: 0, y: 340 },
    { id: "home_t3", x: 110, y: 340 },
  ];

  for (let i = 0; i < fixedHoles.length; i++) {
    const fh = fixedHoles[i];
    registerHole(fh.x, fh.y);
    if (!mapState.holeEls[fh.id]) {
      const h = document.createElement("div");
      h.className = "hole-spot";
      h.dataset.id = fh.id;
      h.style.left = fh.x - HOLE_W / 2 + "px";
      h.style.top = fh.y - HOLE_W / 2 + "px";
      world.appendChild(h);
      mapState.holeEls[fh.id] = h;
      if (mapState.gravesData[fh.id]) {
        restoreGrave(h, mapState.gravesData[fh.id]);
      } else {
        renderGravePlaceholder(h, { holeId: fh.id });
      }
    }
  }

  // Alberi fissi ai lati del tempio (simmetrici)
  const fixedTrees = [
    { x: -190, y: -80, sz: 80 },
    { x: 190, y: -80, sz: 75 },
    { x: -185, y: 80, sz: 70 },
    { x: 185, y: 80, sz: 72 },
  ];
  for (let i = 0; i < fixedTrees.length; i++) {
    const ft = fixedTrees[i];
    registerDecor(ft.x, ft.y, ft.sz / 2);
    const el = document.createElement("div");
    el.className = "decor tree";
    el.style.left = ft.x - ft.sz / 2 + "px";
    el.style.top = ft.y - ft.sz / 2 + "px";
    el.style.width = ft.sz + "px";
    world.appendChild(el);
  }

  // Pietre decorative
  const fixedStones = [
    { x: -140, y: -230, sz: 35 },
    { x: 140, y: -230, sz: 32 },
    { x: -145, y: 235, sz: 30 },
    { x: 145, y: 235, sz: 33 },
  ];
  for (let i = 0; i < fixedStones.length; i++) {
    const fs = fixedStones[i];
    registerDecor(fs.x, fs.y, fs.sz / 2);
    const el = document.createElement("div");
    el.className = "decor stone";
    el.style.left = fs.x - fs.sz / 2 + "px";
    el.style.top = fs.y - fs.sz / 2 + "px";
    el.style.width = fs.sz + "px";
    world.appendChild(el);
  }

  // Fiori pixel art decorativi
  const fixedFlowers = [
    { x: -120, y: -140, sz: 12, c: 0 },
    { x: 120, y: -140, sz: 11, c: 2 },
    { x: -50, y: -250, sz: 10, c: 1 },
    { x: 50, y: -250, sz: 9, c: 3 },
    { x: -115, y: 145, sz: 11, c: 4 },
    { x: 115, y: 145, sz: 10, c: 5 },
    { x: -55, y: 255, sz: 12, c: 6 },
    { x: 55, y: 255, sz: 11, c: 7 },
    { x: -230, y: -20, sz: 14, c: 1 },
    { x: 230, y: -20, sz: 13, c: 3 },
    { x: -225, y: 25, sz: 12, c: 5 },
    { x: 225, y: 25, sz: 11, c: 2 },
  ];
  for (let i = 0; i < fixedFlowers.length; i++) {
    const ff = fixedFlowers[i];
    registerDecor(ff.x, ff.y, ff.sz / 2);
    const flower = createPixelFlower(ff.sz, ff.c);
    flower.style.left = ff.x - ff.sz / 2 + "px";
    flower.style.top = ff.y - ff.sz + "px";
    world.appendChild(flower);
  }
}
